export default __webpack_public_path__ + "static/media/3414.815f2cfd.png";